import { apiClient } from './client';
import { getGuestChatHeaders } from './chatCreation.service';
import type {
  CelebrationDiscoveryRequest,
  CelebrationDiscoveryResult,
} from '@om/shared-types';

export type { CelebrationDiscoveryRequest, CelebrationDiscoveryResult };

export async function sendDiscoveryMessage(
  request: CelebrationDiscoveryRequest,
): Promise<CelebrationDiscoveryResult> {
  const response = await apiClient.post<{ success: boolean; data: CelebrationDiscoveryResult }>(
    '/chat/discovery',
    request,
    { headers: getGuestChatHeaders() },
  );

  return response.data.data;
}
